import { render, staticRenderFns } from "./_base-load-more.vue?vue&type=template&id=12fd08ba&scoped=true"
import script from "./_base-load-more.vue?vue&type=script&setup=true&lang=js"
export * from "./_base-load-more.vue?vue&type=script&setup=true&lang=js"
import style0 from "./_base-load-more.vue?vue&type=style&index=0&id=12fd08ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fd08ba",
  null
  
)

export default component.exports